import { HALApiService } from '../hal-api.service'
import { createItemsData } from '../../helpers/request-helpers'
import { QueueService } from './base-service'
import qs from 'qs'
import { QueueUtils } from '../../utils/queue.utils'
import { filterUtil } from '../../utils/filter.util'
const utils = new QueueUtils(filterUtil)

export const pickingSequenceService = new QueueService('/storage/tasks/sequence', HALApiService, createItemsData, utils, qs)